module.exports = __webpack_public_path__ + "static/img/icon_beian.708c3967.svg";